export default __webpack_public_path__ + "static/media/paperplane.0b2854be.svg";